import { useContext, useEffect, useState } from "react";
import {
	GetSessionStorageItem,
	getUrlQuery,
	SetSessionStorageItem,
} from "@/shared/utils";
import { TResponse, TVariables } from "@/shared/types";
import { HttpRequest } from "@/shared/request";
import { CMSAPI } from "@/config/api";
import { useCmsStore } from "../AppHooks";
import { Dropdown } from "./Dropdown";
const languageMapping: TVariables = {
	da: "Dansk",
	de: "Deutsch",
	en: "English",
	fr: "Français",
	nl: "Nederlands",
	es: "Español",
	uk: "Українська",
	ru: "Русский",
	tc: "繁體中文",
	zh: "简体中文",
};
interface TDropDownItem {
	id: string | number;
	value: string | number;
}
function LanguageDropdown(props: { wrapClass?: string }) {
	const { locale } = useCmsStore()!
	useEffect(() => {
		initLanguageList();
	}, []);
	const [languageList, setLanguageList] = useState<Array<TDropDownItem>>([]);
	async function initLanguageList() {
		const urltoken = getUrlQuery("token");
		if (!urltoken || locale !== "en-row") return;
		const cacheKey = locale + "-" + urltoken;
		const cacheValue = GetSessionStorageItem(
			"languageList",
			cacheKey,
			1000 * 60 * 5
		);
		if (cacheValue) {
			setLanguageList(cacheValue);
			return;
		}
		const fetchRes = await HttpRequest.post(`${CMSAPI}`, {
			locale: "es-row",
			contentType: "storeList",
			select_fields: ["title", "storeEnable"],
			title: urltoken,
		})
		const { data, success } = fetchRes.data;
		if (success) {
			if (data.length > 0) {
				setLanguageList([
					{
						id: 'es-row',
						value: languageMapping['es'] as string,
					}
				]);
			}
		}
	}

	const selectedLanguage = (selected: any) => {
		const originalPath = location.pathname;
		let path = `${originalPath.replace(locale, selected.id)}`;
		let param = new URLSearchParams(location.search);
		param.set("agp", "true");
		location.href = path + "?" + param.toString();
	};
	return (
		<>
			{languageList.length > 0 && (
				<Dropdown
					wrapClass={props.wrapClass}
					options={languageList}
					defaultSelected={{
						id: locale,
						value: languageMapping[locale.split("-")[0]] as string,
					}}
					onSelect={selectedLanguage}
					disableChangeSelected={true}
				/>
			)}
		</>
	);
}

export default LanguageDropdown;
